<!--
 * @Description: 
 * @Date: 2023-01-04 18:48:26
-->
<template>
  <el-form-item
    v-if="
      ruleForm.isTargetNameRule !== 0 ||
        [1, 2, 3, 9, 10, 13].includes(+ruleForm.szVisitType)
    "
    label="目标姓名脱敏规则："
    prop="tmTargetNameRule"
  >
    <div v-if="ruleForm.isTargetNameRule === 2 || ruleForm.szVisitType === 13">
      <el-radio
        :disabled="$attrs.disabled"
        :value="value"
        @input="v => $emit('input', v)"
        :label="5"
      >
        四字补齐
      </el-radio>
      <el-radio
        :disabled="$attrs.disabled"
        :value="value"
        @input="v => $emit('input', v)"
        :label="4"
      >
        不处理
      </el-radio>
    </div>

    <el-radio-group
      v-else
      style="display:flex;align-items:center"
      :value="value"
      @input="v => $emit('input', v)"
      :disabled="$attrs.disabled"
    >
      <el-radio :label="1">
        部分隐藏
        <span style="color:rgb(177, 177, 177)">例：王*二</span>
      </el-radio>
      <el-radio :label="2">
        字母缩写
        <span style="color:rgb(177, 177, 177)">例：WZS</span>
      </el-radio>
      <el-radio :label="3">
        CRF 四字缩写
      </el-radio>
      <el-tooltip
        effect="dark"
        placement="top-end"
        style="transform: translateX(-25px)"
      >
        <div slot="content">
          <p>
            两字姓名取拼音前2个字母（张三ZHSA）；
            三字姓名取三字首字母及第三字第二
          </p>
          <p>
            字母（李思思LSSI）；四字姓名取每字首字母（欧阳晓倩OYXQ）；
            姓名全拼不
          </p>
          <p>足4个字母，双写第3个字母（安娥ANEE）</p>
        </div>
        <el-button type="text" icon="el-icon-warning-outline"></el-button>
      </el-tooltip>
    </el-radio-group>
  </el-form-item>
</template>

<script>
export default {
  name: 'tmTargetNameRule',
  props: ['value', 'ruleForm']
};
</script>

<style scoped></style>
